export default __webpack_public_path__ + "static/media/library.222169a7.JPG";